import moment from 'moment';
import * as yup from 'yup';
import { DependentType } from '../../api/usePersonalInfoQuery';

export interface FormDependent {
  id: string;
  firstName: string;
  yearOfBirth: string;
  type: DependentType;
  isDependent: boolean;
}

export interface DependentsFormValues {
  dependents: FormDependent[];
}

export const NEW_DEPENDENT = {
  id: '',
  firstName: '',
  type: DependentType.Child,
  yearOfBirth: '',
  isDependent: true,
};

export const DEPENDENT_NAME_MAP = {
  [DependentType.Child]: 'Child',
  [DependentType.Grandchild]: 'Grandchild',
  [DependentType.OtherDependent]: 'Other Dependent',
  [DependentType.Charity]: 'Charity',
  [DependentType.OtherBeneficiary]: 'Other Beneficiary',
};

export const DEPENDENT_TYPE_OPTIONS = [
  {
    value: DependentType.Child,
    label: DEPENDENT_NAME_MAP[DependentType.Child],
  },
  {
    value: DependentType.Grandchild,
    label: DEPENDENT_NAME_MAP[DependentType.Grandchild],
  },
  {
    value: DependentType.OtherDependent,
    label: DEPENDENT_NAME_MAP[DependentType.OtherDependent],
  },
  {
    value: DependentType.Charity,
    label: DEPENDENT_NAME_MAP[DependentType.Charity],
  },
  {
    value: DependentType.OtherBeneficiary,
    label: DEPENDENT_NAME_MAP[DependentType.OtherBeneficiary],
  },
];

export const DESCENDANTS = [DependentType.Child, DependentType.Grandchild];

export const BENEFICIARIES = [DependentType.Charity, DependentType.OtherBeneficiary];

export const dependentsValidation = yup.array().of(
  yup.object().shape({
    firstName: yup.string().required('First name is required.'),

    yearOfBirth: yup
      .string()
      .when('type', (type, schema) => {
        if (BENEFICIARIES.includes(type)) {
          return schema;
        }

        return schema.required('Year of birth is required');
      })
      .when('type', (type, schema) => {
        if (BENEFICIARIES.includes(type)) {
          return schema;
        }

        return schema.test('yob', 'Year of birth is invalid.', value => {
          if (!value) {
            // Let the .required() test handle it
            return true;
          }

          const parsedDate = moment(value, 'YYYY', true);

          return parsedDate.isValid() && moment().diff(parsedDate, 'years') <= 120;
        });
      }),
  }),
);

export interface DependentToUpdate {
  index: number;
  type: DependentType;
  newType: DependentType;
}

export interface DependentToDelete {
  index: number;
}
